import { Injectable, RendererFactory2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DomService } from '@nibtravel/shared/util/dom';

import { BaseGtmProvider } from './base.gtm.provider';

@Injectable({ providedIn: 'root' })
export class DefaultGtmProvider extends BaseGtmProvider {
  constructor(service: DomService, router: Router, factory: RendererFactory2) {
    super(service, router, factory);
  }

  urlTracker = (event: NavigationEnd) => event.urlAfterRedirects;
  virtualTracker = (_: NavigationEnd) => undefined;
  campaignTrackers = () => undefined;
}
